/* src/app/shared/components/summary-cards/summary-cards.component.scss */
.summary-scroll {
  display: flex;
  flex-wrap: nowrap;
  gap: 16px;
  overflow-x: auto;
}
.summary-card {
  padding: 4px 12px;
  border-radius: 8px;
  border: 1px solid var(--primary-subtle-default);
  background: var(--contrast-inverse);
  display: flex;
  align-items: center;
  gap: 12px;
  color: var(--ion-text-color);
}
@media (max-width: 1199px) {
  .summary-card {
    padding: 8px 16px;
  }
}
.summary-icon {
  margin-left: -8px;
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--secondary-subtle-default);
  color: var(--secondary-default);
}
.summary-icon .pi {
  font-size: 20px;
}
@media (max-width: 1199px) {
  .summary-icon {
    display: none;
  }
}
.summary-content {
  min-width: 0;
  display: flex;
  flex-direction: row;
  gap: 16px;
  align-items: center;
}
@media (max-width: 1199px) {
  .summary-content {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
}
.summary-title {
  font-size: 14px;
  line-height: 20px;
  font-weight: 500;
  color: var(--text-default);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
}
.summary-value {
  font-size: 20px;
  font-weight: 500;
  line-height: 28px;
  color: var(--text-default);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.summary-value-composite {
  display: inline-flex;
  align-items: flex-end;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}
.summary-value-main {
  font-size: 24px;
  font-weight: 600;
  line-height: 32px;
}
@media (max-width: 1199px) {
  .summary-card {
    flex: 0 0 180px;
    min-width: 150px;
    max-width: 300px;
  }
  .summary-title {
    white-space: normal;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
  }
}
/*# sourceMappingURL=summary-cards.component.css.map */
